import type { CSSProperties } from 'react';

/** Shared inline styles for `CartPage` (left column + continue shopping). */
export const cartPageStyles: Record<string, CSSProperties> = {
  heading: {
    marginTop: '0',
    marginBottom: '25px',
    fontSize: '24px',
    fontWeight: 'bold',
    borderBottom: '1px solid #ccc',
  },

  linkButton: {
    background: 'none',
    color: '#08c',
    border: 'none',
    cursor: 'pointer',
    fontSize: '14px',
  },

  select: {
    marginLeft: '6px',
    padding: '3px 6px',
    fontSize: '0.9rem',
    border: '1px solid #ccc',
    borderRadius: '4px',
    background: '#fff',
  },
};
